import { motion } from "motion/react";

import { GlobalSearchPassengerItemSkeleton } from "./GlobalSearchPassengerItem";

function GlobalSearchDialogSkeleton() {
    return Array.from({ length: 2 })
        .fill(0)
        .map((_, index) => (
            <motion.div
                key={index}
                variants={{
                    hidden: { opacity: 0, y: 20 },
                    visible: {
                        opacity: 1,
                        y: 0,
                        transition: {
                            duration: 0.4,
                            ease: "easeOut",
                        },
                    },
                }}
            >
                <GlobalSearchPassengerItemSkeleton />
            </motion.div>
        ));
}
export default GlobalSearchDialogSkeleton;
